/** @jsxImportSource @emotion/react */
import { FC, useMemo } from "react"
import MarketTable from "components/Market/MarketTable"
import { useTranslation } from "translation"
import { useStyles } from "components/Market/styles"
import { Grid, Paper, Skeleton, Typography } from "@mui/material"
import { formatCentsToReadableValue } from "utilities/formatting"
import { Market } from "types"
import useGetMarkets from "queries/getMarkets/useGetMarkets"

const Market: FC = () => {
  const { t } = useTranslation()
  const styles = useStyles()

  const { data: marketsData = { markets: [] as Market[] } } = useGetMarkets({ placeholderData: { markets: [] } })

  const { totalSupplyUsd, totalBorrowsUsd, totalBalanceUsd, totalLiquidityUsd } = useMemo(() => {
    const data = marketsData.markets.reduce(
      (acc: any, curr: Market) => {
        acc.totalBalanceUsd = acc.totalBalanceUsd + curr.totalSupplyUsd - curr.totalBorrowsUsd
        acc.totalLiquidityUsd = acc.totalBalanceUsd

        acc.totalSupplyUsd += curr.totalSupplyUsd
        acc.totalBorrowsUsd += curr.totalBorrowsUsd

        return acc
      },
      {
        totalSupplyUsd: 0,
        totalBorrowsUsd: 0,
        totalBalanceUsd: 0,
        totalLiquidityUsd: 0,
      },
    )
    return data
  }, [marketsData])

  return (
    <>
      <div css={styles.headerRoot}>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={6}>
            <Paper css={styles.box}>
              <Typography variant="body2" css={styles.title}>
                {t("market.totalSupply")}
              </Typography>
              <Typography variant="h4" css={styles.value}>
                {totalSupplyUsd > 0 &&
                  formatCentsToReadableValue({
                    shortenLargeValue: true,
                    value: totalSupplyUsd * 100,
                  })}
                {totalSupplyUsd === 0 && <Skeleton animation="wave" sx={{ borderRadius: "8px", width: "3em" }} />}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Paper css={styles.box}>
              <Typography variant="body2" css={styles.title}>
                {t("market.totalBorrow")}
              </Typography>
              <Typography variant="h4" css={styles.value}>
                {totalBorrowsUsd > 0 &&
                  formatCentsToReadableValue({
                    shortenLargeValue: true,
                    value: totalBorrowsUsd * 100,
                  })}
                {totalBorrowsUsd === 0 && <Skeleton animation="wave" sx={{ borderRadius: "8px", width: "3em" }} />}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </div>
      <MarketTable />
    </>
  )
}

export default Market
